import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import QrReader from 'react-qr-scanner';
import '../styles/QrScannerComponent.css';
import { useAuth } from '../context/AuthContext';
// import BatchInfoCard from './BatchInfoCard';

import { API_BASE } from '../config';

const QrScanner2 = () => {
  const { token } = useAuth();
  const { po_number, cart_code, sku_code } = useParams();
  const location = useLocation();
  const [item, setItem] = useState(null);
  const [formattedLocation, setFormattedLocation] = useState('');
  const [isScannerReady, setIsScannerReady] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      if (!token) {
        console.error('No token available');
        return;
      }

      try {
        const response = await fetch(`${API_BASE}/get-po/?po_number=${po_number}`, {
          headers: {
            'Authorization': `Token ${token}`
          }
        });

        if (response.ok) {
          const data = await response.json();
          if (data) {
            const foundItem = data.items.find(item => item.sku_code === sku_code);
            if (foundItem) {
              setItem(foundItem);
              const { rack, shelf } = foundItem.picking_positions || {};
              setFormattedLocation(`${rack}-${shelf}`);
              setIsScannerReady(true);
            } else {
              console.error(`No se encontró el item con el SKU: ${sku_code}`);
            }
          }
        } else {
          console.error('Error al cargar el pedido:', response.statusText);
        }
      } catch (err) {
        console.error('Error de conexión:', err.message);
      }
    };

    // Try to use navigation state first, if not available fetch data
    if (location.state?.orderData) {
      const foundItem = location.state.orderData.items.find(item => item.sku_code === sku_code);
      if (foundItem) {
        setItem(foundItem);
        const { rack, shelf } = foundItem.picking_positions || {};
        setFormattedLocation(`${rack}-${shelf}`);
        setIsScannerReady(true);
      }
    } else {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, po_number, sku_code]);

  const handleScan = (result) => {
    if (result && typeof result.text === 'string') {
      const scannedCode = result.text.trim();
      console.log('Código QR escaneado:', scannedCode);

      if (scannedCode === formattedLocation) {
        if (item.format_unit_kg) {
          navigate(`/picker/${po_number}/${cart_code}/${sku_code}/${formattedLocation}/informacion`);
        } else {
          navigate(`/picker/${po_number}/${cart_code}/${sku_code}/${formattedLocation}`);
        }
      } else {
        alert('La ubicación es incorrecta. Por favor, intente nuevamente.');
      }
    } else if (result) {
      console.warn('El resultado escaneado no contiene texto válido:', result);
    }
  };

  const handleError = (error) => {
    console.error('Error al escanear:', error);
  };

  return (
    <div className="qrscanner-container">
      <button onClick={() => navigate(`/picker/${po_number}/${cart_code}`)} className="qrscanner-back-button">
        &#8592;
      </button>

      <h1 className="qrscanner-title">Escanea ubicación {formattedLocation}</h1>

      {/* <BatchInfoCard pickingPosition={item?.picking_positions} /> */}

      <div className="qrscanner-video-container">
        {isScannerReady ? (
          <QrReader
            delay={300}
            onError={handleError}
            onScan={handleScan}
            style={{ width: '100%' }}
            constraints={{
              video: {
                facingMode: 'environment', // Force back camera
              },
            }}
          />
        ) : (
          <div className="loading-container">
            <div className="spinner"></div>
          </div>
        )}
      </div>
    </div>
  );
};

export default QrScanner2;
